import getGlobalProperty from './getGlobalProperty.js';
import rejectIfAborted from '../promise/rejectIfAborted.js';

let resultPromise;

/**
 * Return OneTrust API
 *
 * @param {AbortSignal} signal
 * @returns {object}
 */
export default (signal = null) => rejectIfAborted((resultPromise ??= getGlobalProperty('OneTrust')), signal);
